import { useMemo } from "react";
import { FeatureCollection } from "geojson";
import { PointOfInterest } from "../../../../generated/gpb/api/route";

export function useOpenRoadsGeoJSON( points: Array<PointOfInterest> ): FeatureCollection
{
    return useMemo( () => ( {
        type: "FeatureCollection",
        features: points
            .filter( p => p.latitude !== undefined && p.longitude !== undefined )
            .map( p => ( {
                type: "Feature",
                properties: {
                    storeName: p.storeName,
                    address: p.address,
                    imageUrl: p.brandImageUrl,
                    copyAddress: p.addressCityState,
                },
                geometry: {
                    type: "Point",
                    coordinates: [ p.longitude, p.latitude ],
                },
            } ) )
    } ), [ points ] );
}
